import { useMutation } from '@apollo/client';
import { useCart, GET_CART_QUERY } from '../../../hooks/useCart';
import { ADDRESSES_QUERY } from '../../../hooks/useAddress/useAddressesQuery';
import { PAYMENT_METHODS_QUERY } from '../../../hooks/usePaymentMethods/usePaymentMethodsQuery/paymentMethodsQuery.rest';
import { useCountry } from '../../CountrySelector';
import { AMAZON_BILLING_AGREEMENT_MUTATION } from './amazonBillingAgreementMutation.rest';

export const useAmazonBillingAgreementMutation = (billingAgreementId: string) => {
  const { cart } = useCart();
  const { country } = useCountry();
  const [mutate, { loading, error }] = useMutation(AMAZON_BILLING_AGREEMENT_MUTATION, {
    variables: {
      input: {
        data: {
          id: billingAgreementId,
          type: 'billing_agreement',
          attributes: {
            billing_agreement_id: billingAgreementId,
            country_code: country.alpha2Code
          }
        }
      }
    },
    refetchQueries: [
      {
        query: GET_CART_QUERY,
        variables: {
          cartId: cart.id,
          cartVersion: cart.attributes.version,
          countryCode: country.alpha2Code
        }
      },
      {
        query: ADDRESSES_QUERY
      },
      {
        query: PAYMENT_METHODS_QUERY
      }
    ],
    awaitRefetchQueries: true
  });

  return [mutate, { loading, error }] as const;
};
